import React, { ReactElement, useState } from 'react'
import { HOVER_AROW_ICON, DEFAULT_AROW_ICON } from './constant'
import { TransitionInPage } from '@components/wrapper/TransitionInPage'

type Props = {
  jumpToId: string
  children: string | ReactElement
}

export const SquareNav = ({ jumpToId, children }: Props): JSX.Element => {
  const [isHover, setIsHover] = useState(false)
  return (
    <span
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className="pt-[5px] pb-[6px] w-full text-[3.4vw] leading-tight text-center hover:text-white hover:bg-[#f0b430] border-2 border-[#f0b430] cursor-pointer lg:hover:cursor-pointer"
    >
      <TransitionInPage {...{ jumpToId }}>
        <div className="flex flex-col justify-center items-center h-full font-bold">
          <div>{children}</div>
          <img
            src={isHover ? HOVER_AROW_ICON : DEFAULT_AROW_ICON}
            width={20}
            height={20}
            className="mt-1 rotate-[270deg]"
          />
        </div>
      </TransitionInPage>
    </span>
  )
}
